module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fieldBody"
  }, _vm._l((_vm.contentList), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.type === 'text') ? _c('amp-text', {
      attrs: {
        "item": item
      }
    }) : (item.type === 'image') ? _c('amp-image', {
      attrs: {
        "item": item
      }
    }) : (item.type === 'iframe') ? _c('amp-iframe', {
      attrs: {
        "item": item
      }
    }) : (item.type === 'blockquote') ? _c('amp-blockquote', {
      attrs: {
        "item": item
      }
    }) : _vm._e(), _vm._l((_vm.alsoReadArticles), function(article, articleIndex) {
      return (_vm.getBodyOptions.alsoRead.enable) ? [(article.insertAtIndex === index && article.isIndexAvailable) ? _c('amp-also-read', {
        key: articleIndex,
        attrs: {
          "data-index": index,
          "article": article
        }
      }) : _vm._e()] : _vm._e()
    })], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3450fae","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/amp/AmpFieldBody.vue
// module id = 1794
// module chunks = 27